export default __webpack_public_path__ + "static/media/icon-star-empty-red.3882aa1e.svg";